<template>
  <div id="selectBranch">
    <el-tooltip placement="top" effect="light" v-if="userDeptRoles_.length === 1">
      <div slot="content" class="content-tooltip-role">
        {{
          buildUserDeptRoleLabel(
            userDeptRoles_.filter((item) => item.id == userDeptRoleId)[0] || {}
          )
        }}
      </div>
      <div class="current-role-active">
        {{
          buildUserDeptRoleLabel(
            userDeptRoles_.filter((item) => item.id == userDeptRoleId)[0] || {}
          )
        }}
      </div>
    </el-tooltip>
    <el-select
      v-else
      v-model="userDeptRoleId"
      class="style-fullWidth"
      size="medium"
      filterable
      @change="userDeptRoleIdChange"
    >
      <el-option
        v-for="item in userDeptRoles_"
        :key="item.id"
        :label="buildUserDeptRoleLabel(item)"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import constants from "../../constants";
import { EventBus } from "../../event-bus";

export default {
  name: "select-branch",
  data() {
    return {
      userDeptRoleId: null,
      userDeptRoles_: null,
    };
  },
  computed: {
    userDeptRoleId_() {
      return this.$route.params.userDeptRoleId;
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
  },
  watch: {
    userDeptRoles(newValue) {
      this.initUserDeptRoles(newValue);
    },
    userDeptRoleId_(newValue) {
      if (newValue && this.userDeptRoleId !== newValue) {
        this.userDeptRoleId = newValue;
        this.$store.commit("changeUserDeptRole", this.userDeptRoleId);
      }
    },
  },
  created() {
    this.userDeptRoleId = this.$store.getters.userDeptRoleId;
    this.initUserDeptRoles(this.userDeptRoles);
    this.registerUserDeptRoleChangeListener();
  },
  methods: {
    initUserDeptRoles(userDeptRoles) {
      this.userDeptRoles_ = [];
      this.userDeptRoles_.push(...(userDeptRoles || []));
      this.userDeptRoles_.sort((item1, item2) => {
        return this.buildUserDeptRoleLabel(item1).localeCompare(
          this.buildUserDeptRoleLabel(item2)
        );
      });
    },

    registerUserDeptRoleChangeListener() {
      EventBus.$on(
        constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE,
        (options) => (this.userDeptRoleId = options.userDeptRoleId)
      );
    },

    buildUserDeptRoleLabel(userDeptRole) {
      return userDeptRole.positionName + " " + userDeptRole.deptName;
    },
    userDeptRoleIdChange() {
      this.$store.commit("changeUserDeptRole", this.userDeptRoleId);
      this.$router.replace({
        name: "dashboard",
        params: { userDeptRoleId: this.userDeptRoleId },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/menu-left/select-branch.vue